module.exports = __webpack_public_path__ + "static/media/Phonecover1024page6.77fb0222.png";